import React, {useState} from "react";
import "./AnalisiAcquaCase.scss";

import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms, AnalisiAcquaType} from "../../../../helpers/enums";
import {Container, Row, Col} from "react-bootstrap";
import Sidebar from "./components/Sidebar/Sidebar";
import PreForm from "./components/PreForm/PreForm";
import Payment from './components/Payment/Payment';
import PostForm from "./components/PostForm/PostForm";
import {Redirect} from "react-router-dom";

const AnalisiAcquaCase = (props) => {
  const [initialStep, setIntialStep] = useState(true);
  const [lastStep, setLastStep] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const paramsMatch = props.match || props.computedMatch;
  const {params} = paramsMatch;

  const {tipo, payment} = params;
  if (!tipo || !AnalisiAcquaType[tipo]) {
    return <Redirect to={"/analisi-acqua/base"}/>;
  }

  const handleContinue = (values, actions) => {
    setPaymentType(values.paymentType);
    setIntialStep(false);
  };

  return (
    <div className="AnalisiAcquaCase" data-testid="AnalisiAcquaCase">
      <Container className="main-container">
        <Row>
          <Col md={4} xs={12} className="left-side">
            <Sidebar type={AnalisiAcquaType[tipo]}/>
          </Col>
          <Col md={8} xs={12} className="right-side">
            {payment ? <Payment status={payment === "success" ? true : false}/> :
              (initialStep ? (
                  <PreForm handleContinue={handleContinue}/>
                ) :
                lastStep ? (
                  <PostForm handleClose={() => setLastStep(false)}/>
                ) : (
                  <CaseGenerator
                    initialValues={{tipo, paymentType}}
                    type={CaseForms.AnalisiAcqua}
                    handleBack={() => setIntialStep(true)}
                    handleClose={() => setLastStep(true)}
                  />
                ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AnalisiAcquaCase;
